module.exports = __webpack_public_path__ + "static/media/my_project_opencaret_down.b7173d08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Shared/Sidebar/my_project_opencaret_down.svg
// module id = 1489
// module chunks = 2